import * as _ from 'lodash';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { IRecipient } from '@nkr/models/recipient';
import EpletMmGraphModal from '@nkr/views/matching/results-new/eplet-mm-graph/eplet-mm-graph-modal';
import { IRowData } from './models';
import { styles } from './styles';

interface IProps {
    recipient: IRecipient,
    waitEstimate: string,
    recipientFwt: string,
    declinePercent: number,
    declineWait: string,
    isPreselectPage?: boolean,
    list: IRowData[],
    onShowMortalityBreakdown?: (recipient: IRecipient) => void,
    onShowFWTBreakdown?: (recipient: IRecipient) => void
}

const RecipientInfo = (props: IProps) => {
    const { bloodType, age, hlaAvoids, cpra4, mortalityRiskPercent } = props.recipient;
    const { aAvoids, bAvoids, drAvoids, bwAvoids, cwAvoids, dqAvoids, dqaAvoids, dpAvoids, avoidDr51, avoidDr52, avoidDr53 } = hlaAvoids;
    const recipientAvoids = aAvoids.length + bAvoids.length + drAvoids.length + bwAvoids.length + cwAvoids.length + dqAvoids.length + dqaAvoids.length + dpAvoids.length + (avoidDr51 ? 1 : 0) + (avoidDr52 ? 1 : 0) + (avoidDr53 ? 1 : 0);

    const ewtInt = props.recipientFwt == "60+" ? 61 : (parseInt(props.recipientFwt) || 0)
    const monthOrMonths = ewtInt <= 1 ? ' month' : ' months';
    const drText = props.recipientFwt.includes('N/A') ? props.recipientFwt : props.recipientFwt + monthOrMonths;
    const pendingCount = props.list.filter(x => x.donor.isAccepted == null && x.isPairedDonor == false).length;
    const [showEpletGraph, setShowEpletGraph] = useState<boolean>(false);
    const expectedWaitTimeLowEmm = props.recipient.expectedWaitTimeLowEmm;
    const lowEpletText = expectedWaitTimeLowEmm == null ? 'N/A' : expectedWaitTimeLowEmm <= 6 ? 'Yes' : 'No';

    return (
        <div>
            <div style={styles.recipientInfoStrip}>
                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>Recipient:</div>
                    <div>{props.isPreselectPage ? <a href={`center/${props.recipient.centerId}/recipient/${props.recipient.id}/profile/general`} target='_blank'>{props.recipient.alias}</a> : props.recipient.alias}</div>
                </div>

                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>ABO:</div>
                    <div>{bloodType}</div>
                </div>

                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>Age:</div>
                    <div>{age}</div>
                </div>

                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>Avoids:</div>
                    <div>{recipientAvoids}</div>
                </div>

                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>CPRA4:</div>
                    <div>{_.round(cpra4, 2)}</div>
                </div>

                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>Forecasted Wait Time:</div>

                    {drText?.includes("N/A") ?
                        <span>{drText}</span>
                        :
                        <Button bsStyle='link' style={styles.linkButton} onClick={() => props.onShowFWTBreakdown(props.recipient)}>
                            {drText}
                        </Button>
                    }
                </div>

                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>1-Year Mortality Risk:</div>
                    {Number(mortalityRiskPercent?.toFixed(0) ?? 0) == 0 ?
                        <span>0%</span>
                        :
                        <Button
                            bsStyle='link'
                            style={styles.linkButton}
                            onClick={() => props.onShowMortalityBreakdown(props.recipient)}
                        >
                            {mortalityRiskPercent?.toFixed(0)}%
                        </Button>
                    }
                </div>

                <div style={styles.recipientInfoItem}>
                    <div style={styles.itemLabel}>Will Encounter Low Eplet MM in 6mo:</div>
                    <Button bsStyle='link' style={styles.linkButton} onClick={() => setShowEpletGraph(true)}>
                        {lowEpletText}
                    </Button>
                </div>
                {props.isPreselectPage && (<>
                    <div style={styles.pendingCount}>
                        {pendingCount} pending/re-eval
                    </div>
                </>)}
            </div>

            <EpletMmGraphModal show={showEpletGraph} recipient={props.recipient} onClose={() => setShowEpletGraph(false)} />
        </div>
    );
};

export default RecipientInfo;